import { MODAL_DRAWER_KEY } from 'app-constants'
import { StoreWithdrawal } from './store-withdrawal'
import { StoreConfirmSubscription } from './store-confirm-subscription'
import { StoreSubscriptionError } from './store-subscription-error'

export function DrawerModalTemplate() {
  return {
    [MODAL_DRAWER_KEY.STORE_WITHDRAWAL]: <StoreWithdrawal />,
    [MODAL_DRAWER_KEY.STORE_CONFIRM_PURCHASE]: <StoreConfirmSubscription />,
    [MODAL_DRAWER_KEY.STORE_SUBSCRIPTION_ERROR]: <StoreSubscriptionError />,
  }
}
